import React, {useState, useEffect, useCallback} from 'react'
import {Table} from 'antd'
import {APIv1} from '../../api'
import {useOutletContext} from "react-router-dom";
import {extractDateBySecond} from "../../utils";
import SmsColumns from "./sms.constants";
import ExportExcelButton from "../../components/Buttons/ExportExcel/ExportExcelButton";
import {useTranslation} from "react-i18next";
import useUrlTableState from "../../hooks/useUrlTableState";
import ListStateIndicator from "../../components/ListStateIndicator/ListStateIndicator";

const SMS_FILTER_PARAM_MAP = {
    is_success: 'is_success',
};

const SMS_FILTER_LABELS = {
    is_success: 'Status',
};

const parseBooleanParam = (value) => value === 'true';

const SMS_FILTER_VALUE_PARSERS = {
    is_success: parseBooleanParam,
};

const Sms = (props) => {
    let companyInn = props.companyInn;
    let defaultPaginationSize = props.defaultPaginationSize !== undefined ? props.defaultPaginationSize : 20;

    const {t} = useTranslation()
    const [userData, setUserData] = useState({})
    const [isUserStaff, setIsUserStaff] = useState({})
    const [loading, setLoading] = useState(true)
    const [smsData, setSmsData] = useState([])
    const [startPeriod, setStartPeriod] = useState(0);
    const [endPeriod, setEndPeriod] = useState(0);
    const [totalSms, setTotalSms] = useState(0)
    const {searchText} = useOutletContext()
    const tableState = useUrlTableState({
        defaultPageSize: defaultPaginationSize,
        filterParamMap: SMS_FILTER_PARAM_MAP,
        filterValueParsers: SMS_FILTER_VALUE_PARSERS,
        filterLabels: SMS_FILTER_LABELS,
        searchText,
    });

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setIsUserStaff(items.data.is_admin)
        }
    }, [isUserStaff]);

    const handleChangePeriod = (value) => {
        if (value === null || value === 0) {
            setStartPeriod(0);
            setEndPeriod(0);
        } else {
            let startPeriod = value[0].format('YYYY-MM-DD');
            let endPeriod = value[1].add(1, 'days').format('YYYY-MM-DD');
            setStartPeriod(startPeriod);
            setEndPeriod(endPeriod);
        }
    }

    const columns = SmsColumns(t, handleChangePeriod);
    const controlledColumns = tableState.controlledColumns(columns);

    const fetchSmsData = useCallback(async (page, size, search = '', ordering = '', filters = {}) => {
        setLoading(true);
        try {
            const queryParams = {
                page,
                page_size: size,
                search,
                ordering,
                ...filters,
            };

            if (filters.period) {
                queryParams.period = filters.period;
            }

            let pre_url = companyInn !== undefined ? `/sms/list/get_related_sms/?company_inn=${companyInn}` : '/sms/list/';
            let url = (startPeriod !== 0 && endPeriod !== 0) ? `${pre_url}?start_period=${startPeriod}&end_period=${endPeriod}` : pre_url
            const response = await APIv1.get(url, {
                params: queryParams,
                headers: {
                    Authorization: `Token ${userData.token}`,
                }
            })
            const data = response.data.results.map(sms => ({
                key: sms.id,
                sms_id: sms.id,
                inn: sms.inn,
                recipient: sms.recipient,
                is_success: sms.is_success,
                created_date: extractDateBySecond(sms.created_date),
            }))
            setSmsData(data)
            setTotalSms(response.data.count)
        } catch (err) {
            console.error('Something went wrong', err)
        } finally {
            setLoading(false)
        }
    }, [companyInn, userData.token, startPeriod, endPeriod]);

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    useEffect(() => {
        fetchSmsData(tableState.currentPage, tableState.pageSize, tableState.search, tableState.ordering, tableState.filters)
    }, [tableState.currentPage, tableState.pageSize, tableState.search, tableState.ordering, tableState.filters, fetchSmsData, startPeriod, endPeriod])

    const tableChangeHandler = tableState.handleTableChange(columns);

    return (
        <>
            <div className='content_container'>
                <ListStateIndicator items={tableState.stateIndicators} onReset={tableState.resetState} onRemove={tableState.removeState}/>
                {isUserStaff ? (
                    <div style={{marginBottom: '15px', display: 'flex', justifyContent: 'flex-end', gap: '15px'}}>
                        <ExportExcelButton
                            t={t}
                            userData={userData}
                            exportUrl="sms/count/export/"
                            dateParamNames={{start: "start_date", end: "end_date"}}
                            buttonLabel="Экспорт количества СМС"
                            fileExtension="xlsx"
                            dateFormat="YYYY-MM-DD"
                            prefixType="SmsCount"
                            includeInn={true}
                        />
                    </div>
                ) : null}

                <Table
                    columns={controlledColumns}
                    dataSource={smsData}
                    loading={loading}
                    onChange={(pagination, filters, sorter, extra) => {
                        tableChangeHandler(pagination, filters, sorter, extra);
                    }}
                    pagination={{
                        total: totalSms,
                        current: tableState.currentPage,
                        pageSize: tableState.pageSize,
                        defaultPageSize: defaultPaginationSize,
                        showSizeChanger: true,
                        defaultCurrent: 1,
                        showTotal: (total, range) => `${range[0]} - ${range[1]} / ${total}`,
                        pageSizeOptions: ['10', '20', '50', '100'],
                    }}
                />
            </div>
        </>
    )
}

export default Sms;
